<template>
  <div>
    <v-menu v-model="menu" close-on-click :nudge-width="200" offset-x>
      <template v-slot:activator="{ on }">
        <v-btn class="text--secondary" text icon rounded v-on="on">
          <img :src="language.icon" height="24px" width="24px" min-width="24px" />
        </v-btn>
      </template>

      <v-card>
        <v-list nav dense>
          <v-list-item-group v-model="selectedLanguage" color="primary">
            <v-list-item v-for="(lang, i) in languages" :key="i">
              <v-list-item-icon>
                <img :src="lang.icon" :alt="lang.code" height="24px" width="24px" min-width="24px" />
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ lang.name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  created() {
    const initialLanguage = this.$store.state.app.language;
    console.log("init lang",initialLanguage)
    this.selectedLanguage = this.languages.findIndex(
      lang => lang.code === initialLanguage
    );
  },
  data() {
    return {
      menu: null,
      selectedLanguage: 0,
      languages: [
        {
          code: "tr_TR",
          name: "Türkçe",
          icon: "/flags/tr.png"
        },
        {
          code: "en_US",
          name: "English",
          icon: "/flags/us.png"
        }
      ]
    };
  },
  computed: {
    language() {
      return this.languages[this.selectedLanguage];
    }
  },
  watch: {
    selectedLanguage() {
      this.$store.dispatch(
        "app/setLanguage",
        this.languages[this.selectedLanguage].code
      );
    }
  }
};
</script>